<div class="top">
    <h4 class="page-title ">APPLICATION DETAILS</h4>

    <span class="material-symbols-outlined text-danger" (click)="back()" role="button">close</span>
</div>

<div class="form-wrapper">
    <form [formGroup]="form">

        <div class="form-section">
            <h5 class="form-section-heading mb-3">ADDRESS:</h5>
            <div class="body">
                <div class=" row g-3">
                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0 required">FIRST NAME</label>
                            <input type="text" placeholder="Enter first name" class="form-control mt-0"
                                formControlName="firstName" maxlength="60" />
                            <app-error-message [form]="form" controlName="firstName"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0 required">LAST NAME</label>
                            <input type="text" placeholder="Enter last name" class="form-control mt-0"
                                formControlName="lastName" maxlength="60" />
                            <app-error-message [form]="form" controlName="lastName"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0">MIDDLE NAME</label>
                            <input type="text" placeholder="Enter middle name" class="form-control mt-0"
                                formControlName="middleName" maxlength="60" />
                            <app-error-message [form]="form" controlName="middleName"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0 required">PHONE NUMBER</label>
                            <input type="text" placeholder="e.g. 09087763552" class="form-control mt-0"
                                formControlName="phoneNumber" maxlength="17" />
                            <app-error-message [form]="form" controlName="phoneNumber"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0 required">EMAIL</label>
                            <input type="text" placeholder="example@gmail.com" class="form-control mt-0"
                                formControlName="email" maxlength="60" />
                            <app-error-message [form]="form" controlName="email"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <div class="field">
                            <label class="mb-0 required">AGE</label>
                            <input type="number" class="form-control mt-0" formControlName="age" max="100" min="0"
                                placeholder="Enter Age" />
                            <app-error-message [form]="form" controlName="age"
                                [showErrorMessage]="showErrorMessages"></app-error-message>
                        </div>
                    </div>





                </div>
            </div>
        </div>

        <div class="form-section mb-0">
            <h5 class="form-section-heading mb-3">OPERATIONAL DETAILS:</h5>
            <div class=" row g-3">

                <div class="col-sm-6 col-md-4">
                    <div class="field">
                        <label class="mb-0 required">COMPOUND NAME/NO</label>
                        <input type="text" placeholder="Enter compound name" class="form-control mt-0"
                            formControlName="compoundName" maxlength="100" />
                        <app-error-message [form]="form" controlName="compoundName"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="field">
                        <label class="mb-0 required">WARD</label>
                        <ng-select [items]="wardList" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                            bindLabel="name" bindValue="id" placeholder="-- Select Option--" formControlName="ward"
                            class="ng-select control"> </ng-select>
                        <app-error-message [form]="form" controlName="ward"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="field">
                        <label class="mb-0 required">STREET</label>
                        <input type="text" placeholder="Enter street" class="form-control mt-0" formControlName="street"
                            maxlength="100" />
                        <app-error-message [form]="form" controlName="street"
                            [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>
                </div>

                <div class="col-sm-6 col-md-4">
                    <div class="field">
                        <label class="mb-0 required"> Approval Letter From Community King or PG</label>
                        <app-upload-input [accept]="'.png, .jpg, .jpeg, .pdf'" [maxFileSize]="1"
                            [isInPreviewMode]="false" (fileChange)="onFileChange($event, 'communityApproval')"
                            (error)="onError($event, 'communityApproval')" [form]="form"
                            controlName="communityApproval"></app-upload-input>

                        <app-error-message [form]="form" [maxFileSize]="1" controlName="communityApproval"
                            label="Image upload" [showErrorMessage]="showErrorMessages"></app-error-message>
                    </div>
                </div>
            </div>
        </div>


    </form>
</div>

<div class="modal-actions-wrapper"
    *ngIf="hasAccess(['CAN_APPROVE_LGA_IDENTIFICATION', 'CAN_QUERY_LGA_IDENTIFICATION']) && dialogData?.approvalStatus == 'PENDING' ">
    <button type="submit" class="btn flex-btn btn-danger w-100" (click)="queryApplication()">
        <span>DECLINE</span>
        <span class="spinner-light" *ngIf="isQueryingApplication"></span>
    </button>

    <button type="submit" class="btn flex-btn btn-success w-100" (click)="approveApplication()">
        <span>APPROVE</span>
        <span class="spinner-light" *ngIf="isApprovingApplication"></span>
    </button>
</div>